import { FC } from 'react';
import { Typography } from '@mui/material';

export const RooftopSelectHelpContent: FC = () => {
  return (
    <Typography variant="body1">
      Your Business's name and location. Rooftops allow you to post job ads for your different companies or locations.
      Ads posted under a Rooftop will display that particular Rooftop's name and location to job seekers. Any updates
      made here will automatically reflect on all associated job ads.
    </Typography>
  );
};

export default RooftopSelectHelpContent;
